export const medicalBotIds = [
    '23467235', // WEMD Reception Bot
    '56725689', // MyClinic Tarneit Reception
    '23857662', // Lake Orr Reception Bot
    '84723345', // Lockridge Reception
    '84723346', // Lockridge Reception Gen 4
    '16426825', // North Brighton Medical Reception
    '56379023', // Okleigh Medical Reception Bot
    '75439631', // Ghan Medical Reception Bot
    '52959275', // Warwick Medical Bot
    '27873478', // Forest Family Reception Bot
    '34723471', // Balgowlah Reception
    '86427892', // Firstlight Ballina
    '87464354', // All Ways Cessnock
    '87464355', // All Ways Kurri Kurri
    '11256773', // Maple Street Surgery
    '11256774', // Sunrise Beach Surgery
    '10011001', // Firstlight Ballina (ForHealth)
    '10011002', // All Ways Cessnock (ForHealth)
    '10011003', // All Ways Kurri Kurri (ForHealth)
    '10011004', // Burwood Healthcare (ForHealth)
    '20012341', // Burwood Healthcare
    '20012001', // Kirrawee Family Medical Practice,
    '43524667', // Tumbarumba Medical
    '44356737', // PHC Salisbury
    '44356738', // PHC Glenelg
    '44356739', // PHC Dover Gardens
    '21345256', // Alfred Road Medical
    '21356789', // Yeppoon Medical
    '11111111', // Top Health Doctors
    '12012001', // Bliss Medical
    '31003100', // Flourish Medical
    '50015001', // First Health SRMG
    '50025002', // First Health DMC
    '60016001', // Palmerston GP FCD Health
    '70017001', // GPs on Bayview
    '70027002', // The Skin Cancer Clinic Claremont
    '70037003', // The Claremont Clinic (Women's Health)
    '80018001', // Brighton Medical Clinic
    '30013001', // Redgum Corowa
    '30023002', // Redgum Howlong
    '30033003', // Redgum Rutherglen
    '90019001', // Doctors at Lavington
    '90029002', // Doctors at Thurgoona
    '13011301', // Zest Medical
    '14011401', // Endocrine and Wellbeing clinic
    '65406540', // Kildare Road Medical Centre
];